import en from "./english";
import du from "./dutch";
export const ERRORS = {
  en,
  du,
};
